'use strict';

require('../shell/includes.js');
require('../../includes/companyData.js');
require('../../includes/graph.js');
require('../../includes/props.js');
require('../dashboard/appIncludes.js');
require('../socialChannelMatrix/widgetIncludes.js');
require('./app.js');
require('./controller.js');
require('./views/companiesPage.js');
require('./bootstrap.js');
